import styled from "styled-components";

const StyledGridLayout = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  justify-content: center;
  margin-bottom: 40px;
`;

const StyledGridColumn = styled.div``;

const StyledGridRow = styled.div`
  display: flex;
  flex-direction: row;
`;

const StyledGridRowTablet = styled.div`
  display: flex;
  flex-direction: row;
`;

export {
  StyledGridLayout,
  StyledGridColumn,
  StyledGridRow,
  StyledGridRowTablet,
};
